import styled from 'styled-components'

export const UsdLabel = styled.div`
  color: ${({theme}) => theme.colors.textSecondary};
  font-size: ${({theme}) => theme.fontSizes.small};
  text-align: center;
  margin-bottom: 15px;
`

export const UsdAmount = styled.div`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-top: 15px;
  color: ${({theme}) => theme.colors.textThird};

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    font-size: 24px;
    margin-top: 0;
  }
`
